import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { setDirection } from "../../Redux/themeSlice";
import { Typography, useTheme } from "@mui/material";
import "./flip.css";

const FlipLanguageSwitcher = () => {
  const dispatch = useDispatch();
  const [isFlipping, setIsFlipping] = useState(false);
  const theme = useTheme();
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    setIsFlipping(true);
    setTimeout(() => {
      const lang = i18n.language.startsWith("en") ? "ar" : "en";
      i18n.changeLanguage(lang);
      dispatch(setDirection({ directionValue: lang === "ar" ? "rtl" : "ltr" }));
      setIsFlipping(false);
    }, 300);
  };

  return (
    <div
      className="language-switcher-container"
      style={{
        transform:
          theme.direction === "rtl"
            ? "translateX(calc(100% - 80px))"
            : "translateX(0)",
      }}
    >
      <div className="flip" onClick={toggleLanguage}>
        <div
          className={`flip-inner ${isFlipping ? "flipping" : ""}`}
          style={{
            transform: isFlipping ? "rotateY(0deg)" : "rotateY(180deg)",
          }}
        >
          <Typography
            sx={{
              borderRadius: 5,
              fontWeight: 500,
              color: theme.palette.whiteblack.contrastText,
              background: theme.palette.cancelText.border,
            }}
            className="flip-front"
          >
            {theme.direction === "ltr" ? "English" : "عربي"}
          </Typography>
          <Typography
            sx={{
              borderRadius: 5,
              fontWeight: 500,
              background: theme.palette.primary.main,
              color: theme.palette.whiteblack.main,
            }}
            className="flip-back"
          >
            {theme.direction === "ltr" ? "عربي" : "English"}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default FlipLanguageSwitcher;
